// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CompletionStatusType, HyperlinkModule } from '../../../../types/Model';

import { S } from './styles';

interface LabModuleProps {
  data: HyperlinkModule;
  status?: CompletionStatusType;
  triggerProgress: () => void;
  handleNextModule: () => void;
}

const LabContent: React.FC<LabModuleProps> = ({ status, triggerProgress, handleNextModule, data }):JSX.Element => {
  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.HyperlinkImage />
          <S.Title><FormattedMessage id="F020" /></S.Title>
        </S.InformationContainer>
      </S.Row>
      <S.Row>
        <S.Button href={data.link} target="_blank" onClick={triggerProgress}><FormattedMessage id="F021" /></S.Button>
      </S.Row>
    </S.Container>
  );
}

export { LabContent as default };
